import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth } from "../../context/AuthContext.jsx";
import styles from "./Admin.module.css";

export default function AdminHome() {
  const { user } = useAuth();
  const role = useSelector((state) => state.login.role);

  return (
    <div>
      <h1 className={styles.title}>Admin</h1>
      <p className={styles.lead}>
        Signed in as {user?.email || "—"} ({role}). Approve tutor applications,
        moderate teacher comments, and remove accounts or lessons when needed.
      </p>
      <div className={styles.panel}>
        <h2>Quick links</h2>
        <div className={styles.actions}>
          <Link className={styles.button} to="/admin/teachers">
            Tutor applications
          </Link>
          <Link className={styles.button} to="/admin/comments">
            Pending comments
          </Link>
          <Link className={styles.button} to="/admin/deletes">
            Deletes
          </Link>
        </div>
      </div>
    </div>
  );
}
